import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import Header from "./header";

const chevronLeft = <FontAwesomeIcon icon={faChevronLeft} />;

const creditsL = [
  { link: "https://www.flaticon.com/authors/becris", title: "Becris" },
  { link: "https://www.freepik.com", title: "Freepik" },
  { link: "https://creativemarket.com/eucalyp", title: "Eucalyp" },
  { link: "https://www.flaticon.com/", title: "Wichai.wi" },
  { link: "https://www.flaticon.com/authors/icongeek26", title: "Icongeek26" },
  { link: "https://smashicons.com/", title: "Smashicons" },
  { link: "https://www.flaticon.com/authors/linector", title: "Linector" },
  { link: "https://www.flaticon.com/authors/good-ware", title: "Good Ware" },
  {
    link: "https://www.flaticon.com/authors/those-icons",
    title: "Those Icons",
  },
  {
    link: "https://www.flaticon.com/authors/dinosoftlabs",
    title: "DinosoftLabs",
  },
  {
    link: "https://www.flaticon.com/authors/pixelmeetup",
    title: "Pixelmeetup",
  },
];

// const creditsR = [
//   {
//     link: "https://www.flaticon.com/authors/pixel-perfect",
//     title: "Pixel perfect",
//   },
//   { link: "https://flat-icons.com/", title: 'Flat Icons">Flat Icons' },
//   { link: "https://www.flaticon.com/authors/darius-dan", title: "Darius Dan" },
//   { link: "https://www.flaticon.com/authors/iconixar", title: "iconixar" },
//   { link: "https://www.flaticon.com/", title: "xnimrodx" },
//   { link: "https://www.flaticon.com/authors/surang", title: "surang" },
//   {
//     link: "https://www.flaticon.com/authors/smalllikeart",
//     title: "smalllikeart",
//   },
//   { link: "https://www.flaticon.com/authors/monkik", title: "monkik" },
//   { link: "https://www.flaticon.com/authors/itim2101", title: "itim2101" },
//   { link: "https://www.flaticon.com/authors/catkuro", title: "catkuro" },
//   { link: "https://www.flaticon.com/authors/wanicon", title: "wanicon" },
// ];

const authorsL = creditsL.map((author, index) => (
  <li key={index}>
    <a href={author.link} target="_blank" rel="noreferrer">
      {author.title}
    </a>{" "}
    from{" "}
    <a href="https://www.flaticon.com/" target="_blank" rel="noreferrer">
      www.flaticon.com
    </a>
  </li>
));

// const authorsR = creditsR.map((author, index) => (
//   <li key={index}>
//     <a href={author.link} target="_blank" rel="noreferrer">
//       {author.title}
//     </a>{" "}
//     from{" "}
//     <a href="https://www.flaticon.com/" target="_blank" rel="noreferrer">
//       www.flaticon.com
//     </a>
//   </li>
// ));

function Credits(props) {
  return (
    <div className="layout">
      <Header />
      <div className="content">
        <div className="animate__animated animate__fadeIn category">
          <div className="group">
            <h3>Image Credits</h3>
            <p className="subtitle">Icons made by </p>
            <div className="row credit-items">
              <div className="col">
                <ul>{authorsL}</ul>
              </div>
              <div className="col">
                <ul>{authorsL}</ul>
              </div>
            </div>
          </div>
          <div className="navigation">
            <div className="row">
              <div className="col prev">
                <Link to="/guide">
                  {chevronLeft}
                  {"Guide"}
                </Link>
              </div>
              <div className="col next"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Credits;
